export interface ShippingZone {
  id: number;
  name: string;
  type: string;
  locations: {
    id: number;
    country_iso2: string;
    state_iso2: string;
  }[];
  free_shipping: {
    enabled: boolean;
    minimum_sub_total: string;
    exclude_fixed_shipping_products: boolean;
  };
  handling_fees: {
    display_separately: boolean;
    fixed_surcharge: string;
  };
  enabled: boolean;
}

export interface ShippingMethodZone {
  id: number;
  name: string;
  type: string;
  settings: {
    rate: number;
  };
  enabled: boolean;
  handling_fees: {
    fixed_surcharge: number;
  };
  is_fallback: false;
}

export type ShippingMethodZones = ShippingMethodZone[];

export enum DeliveryType {
  FlatRate = 'Flat Rate',
  FreeShipping = 'Free Shipping',
}
